import { MutableRefObject } from 'react';
import { styled } from 'styled-components';
import Input from 'components/ui/Input';

type CommentCellProps = {
    value: string;
    onChange: (value: string) => void;
    disabled?: boolean;
    rowIndex: number;
    colIndex: number;
    cellInputRefs?: MutableRefObject<{
        [key: string]: unknown;
    }>;
    handleArrowKeyDown?: (e: React.KeyboardEvent, itemId: any, rowIndex: any, colIndex: any) => void;
};

const CommentCell = ({
    value,
    onChange,
    disabled = false,
    rowIndex,
    colIndex,
    cellInputRefs,
    handleArrowKeyDown,
}: CommentCellProps) => {
    return (
        <StyledInput
            type="text"
            value={value}
            onChange={(event) => onChange(event.target.value)}
            disabled={disabled}
            rounded
            ref={(el) => {
                if (cellInputRefs && el) {
                    cellInputRefs.current[`additionalCosts-${rowIndex}-${colIndex}`] = el;
                }
            }}
            onKeyDown={(e) => handleArrowKeyDown?.(e, 'additionalCosts', rowIndex, colIndex)}
        />
    );
};

export default CommentCell;

const StyledInput = styled(Input)`
    width: 100%;
    flex: 1;
    input {
        height: 32px !important;
        width: 100% !important;
        padding-left: 8px !important;
    }
`;
